var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99999 4.78765C6.33137 4.78765 6.6 5.05628 6.6 5.38766V8.98766C6.6 9.31904 6.33136 9.58765 5.99999 9.58765C5.66861 9.58765 5.4 9.31904 5.4 8.98766V5.38766C5.4 5.05629 5.66861 4.78765 5.99999 4.78765Z",
    fill: "#D4D4D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99999 2.43072C6.33137 2.43072 6.6 2.69934 6.6 3.03071C6.6 3.36208 6.33136 3.6307 5.99999 3.6307C5.66861 3.6307 5.4 3.36208 5.4 3.03071C5.4 2.69934 5.66861 2.43073 5.99999 2.43072Z",
    fill: "#D4D4D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99999 0C9.31366 0 12 2.68631 12 6.00001C12 9.31369 9.31366 12 5.99999 12C2.68628 12 2.66732e-06 9.31369 0 6.00001C0 2.68631 2.68628 4.75474e-06 5.99999 0ZM5.99999 1.20001C3.34902 1.20001 1.20001 3.34905 1.20001 6.00001C1.20001 8.65099 3.34903 10.8 5.99999 10.8C8.65096 10.8 10.8 8.65099 10.8 6.00001C10.8 3.34905 8.65096 1.20001 5.99999 1.20001Z",
    fill: "#D4D4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d00725448a38d30cfefec0629537c174.svg";
export { ForwardRef as ReactComponent };